import { Tooltip } from 'antd';
import { ButtonType } from 'antd/lib/button/button';
import React, { FC, ReactNode } from 'react';
import { Button } from 'components/atoms/button';
import styles from './approval.module.css';

interface CallToActions {
  onOk: () => void;
  okText: React.ReactNode;
  onCancel: () => void;
  cancelText: React.ReactNode;
  cancelBtnType?: ButtonType;
  disableOk: boolean;
  loading: boolean;
  okTooltipTitle?: ReactNode | string;
}

export const CallToActions: FC<CallToActions> = (props) => {
  const {
    onOk,
    onCancel,
    okText,
    cancelText,
    loading,
    disableOk = false,
    okTooltipTitle,
  } = props;

  return (
    <div className={styles.cta__wrapper}>
      <Tooltip trigger={['hover']} title={okTooltipTitle}>
        <Button
          type="primary"
          size="small"
          disabled={disableOk}
          onClick={onOk}
          loading={loading}
        >
          {okText}
        </Button>
      </Tooltip>
      <Button
        className={styles.cta__cancel}
        size="small"
        onClick={onCancel}
        disabled={loading}
      >
        {cancelText}
      </Button>
    </div>
  );
};
